"use client";
import { Label } from "@/components/ui/label";
import { useEffect, useRef } from "react";
import { useIsMobile } from "@/hooks/use-mobile";

interface AdminPopoverProps {
    admin?: boolean;
    children: React.ReactNode;
    className?: string;
    title?: string;
    onClick: () => void;
    isOpen?: boolean;
    onClose?: () => void;
}

export default function AdminPopover({
    admin,
    children,
    className,
    title,
    onClick,
    isOpen,
    onClose,
}: AdminPopoverProps) {
    const popoverRef = useRef<HTMLDivElement>(null);
    const isMobile = useIsMobile();
    useEffect(() => {
        if (isOpen && popoverRef.current && isMobile) {
            popoverRef.current.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        }
    }, [isOpen, isMobile]);

    if (!admin) {
        return <>{children}</>;
    }

    return (
        <div
            ref={popoverRef}
            onClick={() => {
                if (isOpen) {
                    onClose?.();
                } else {
                    onClick();
                }
            }}
            className={`group relative z-40 w-full cursor-pointer rounded-md border-2 p-1 transition-all duration-300 hover:border-solid hover:border-primary data-[state=open]:border-solid data-[state=open]:border-primary
            ${isOpen ? "border border-primary" : "border-transparent"}
            ${className}`}
        >
            <div className="relative flex w-full cursor-pointer flex-col gap-1">
                <div
                    className={`absolute -right-1 -top-1 z-40 flex items-center rounded-bl-md bg-primary p-1 opacity-0 transition-all duration-300 group-hover:opacity-100
                    ${isOpen && "opacity-100"}`}
                >
                    <Label variant="toggle">{title}</Label>
                </div>
                <div className={`w-full ${admin && ""}`}>
                    <div
                        className={`w-full ${admin && "absolute left-0 top-0 z-40 flex h-full justify-center rounded-md transition-all duration-300 group-hover:bg-primary/30"}`}
                    />
                    {children}
                </div>
            </div>
        </div>
    );
}
